<template>
  <div :class="ns.e('jump')" :disabled="disabled">
    <span>{{ t('b.pagination.goto') }}</span>
    <b-input
      size="small"
      :class="[ns.e('editor'), ns.is('in-pagination')]"
      :min="1"
      :max="pageCount"
      :disabled="disabled"
      :model-value="innerValue"
      type="number"
      @update:model-value="handleInput"
      @change="handleChange"
    />
    {{ t('b.pagination.pageClassifier') }}
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useLocale, useNamespace } from '@bigin/hooks'
import BInput from '@bigin/components/input'
import { usePagination } from '../usePagination'
import { jumperProps } from './jumper'

defineOptions({
  name: 'BPaginationJumper',
})

defineProps(jumperProps)

const { t } = useLocale()
const ns = useNamespace('pagination')
const { pageCount, disabled, currentPage, changeEvent } = usePagination()
const userInput = ref<number>()
const innerValue = computed(() => userInput.value ?? currentPage?.value)

function handleInput(val: number | string) {
  userInput.value = +val
}

function handleChange(val: number | string) {
  val = Math.trunc(+val)
  changeEvent?.(+val)
  userInput.value = undefined
}
</script>
